<div class="flex flex-col h-full bg-shui-base-3" data-testid="details-refer-out-dialog">
    <header
        class="flex items-center justify-between border-solid border-0 border-b-2 border-b-shui-base-4 p-4 flex-shrink-0"
    >
        <span class="text-base text-shui-text-strong font-semibold">
            {{ 'nam.parallel-referral-dialog.title' | translate }}
        </span>
        <sh-button (click)="close()" icon="cancel" layout="normal" color="secondary" size="s"></sh-button>
    </header>
    <div class="flex-1 overflow-y-auto p-4">
        <div class="flex flex-col gap-4">
            <p class="text-sm text-shui-text-subtle m-0">{{ description() | translate }}</p>
            <hr class="border-0 border-t border-shui-base-4 m-0" />
            <p class="text-sm text-shui-text-subtle m-0">
                {{
                    'nam.parallel-referral-dialog.refer-out-counter'
                        | translate: { max: maxReferrals(), count: forms().length }
                }}
            </p>
            <div class="flex items-center gap-2">
                <sh-tabs>
                    @for (form of forms(); track $index) {
                        <sh-tab-item
                            [label]="getTabLabel($index)"
                            [attr.active]="activeTabIndex() === $index ? true : null"
                            [attr.closable]="forms().length > MIN_REFERRALS ? true : null"
                            (click)="setActiveTab($index)"
                            (closed)="removeReferral($index)"
                        ></sh-tab-item>
                    }
                </sh-tabs>
                @if (canAddTab()) {
                    <sh-button
                        icon="plus"
                        icon-position="left"
                        layout="compact"
                        color="secondary"
                        [label]="'nam.parallel-referral-dialog.add-tab' | translate"
                        size="max-content"
                        (click)="addReferral()"
                    ></sh-button>
                }
            </div>
            @for (form of forms(); track $index) {
                <sh-referral-tab
                    [style.display]="activeTabIndex() === $index ? 'block' : 'none'"
                    [form]="form"
                    [canMarkCommentAsInternal]="!!data.canMarkCommentAsInternal"
                    [isReferredOutAfterSubmission]="!!data.isReferredOutAfterSubmission"
                    [excludeIds]="getExcludeIds($index)"
                    [businessService]="data.businessService"
                    [roles]="data.roles || [rolesEnum.TASK_OWNER]"
                ></sh-referral-tab>
            }
        </div>
    </div>
    <div
        class="flex justify-between items-center gap-2 p-4 border-solid border-0 border-t-2 border-t-shui-base-4 flex-shrink-0"
    >
        <sh-button
            [label]="'common.general.cancel' | translate"
            layout="compact"
            color="secondary"
            size="max-content"
            (click)="close()"
        ></sh-button>
        <sh-button
            data-testid="details-refer-out-dialog-button-confirm"
            [label]="'nam.parallel-referral-dialog.confirm' | translate"
            layout="compact"
            size="max-content"
            [disabled]="isConfirmDisabled()"
            [attr.tooltip]="
                isConfirmDisabled() ? ('nam.parallel-referral-dialog.forms-invalid-tooltip' | translate) : null
            "
            (click)="confirm()"
        ></sh-button>
    </div>
</div>
